import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import vector from '../assests/HikeHealth-GSFinaldesign.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const location = useLocation();

  return (
    <div className="relative w-full overflow-x-hidden box-sizing-border">
      <div className="bg-[#D9D9D9] fixed top-0 left-0 w-full z-50 box-sizing-border">
        <div className="bg-[#FFFFFF] flex flex-row justify-between items-center md:p-4 lg:p-6 w-full h-[2rem] box-sizing-border">
          <div className="flex items-center">
            <Link
              to="/"

              className="flex items-center cursor-pointer"
            >
              <img
                src={vector}
                alt="Logo"
                className="mr-2 mt-2 mx-5 w-[70px] h-[70px] md:w-[65px] md:h-[65px]"
              />
              <span className="font-Poppins font-semibold text-md md:text-md lg:text-2xl tracking-[0.5px] text-[#2a627a]">
                HIKEHEALTH GS
              </span>
            </Link>
          </div>

          {/* <div className="hidden md:flex items-center space-x-4 md:space-x-4 lg:space-x-8 ">
      
        <Link
              to="/"
              className={`nav-link cursor-pointer sm:text-sm md:text-[13px] lg:text-[15px] ${
                location.pathname === "/" ? "active" : ""
              }`}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`nav-link cursor-pointer sm:text-sm lg:text-[15px] md:text-[13px] ${
                location.pathname === "/about" ? "active" : ""
              }`}
            >
              About us
            </Link>
        
            <Link
              to="/services"
              className={`nav-link cursor-pointer sm:text-sm lg:text-[15px] md:text-[13px] ${
                location.pathname === "/services" ? "active" : ""
              }`}
            >
              Services
            </Link>
            <Link
              to="/Tech"
              className={`nav-link cursor-pointer sm:text-sm lg:text-[15px] md:text-[13px] ${
                location.pathname === "/Tech" ? "active" : ""
              }`}
            >
              Tech Stacks
            </Link>
            <Link
              to="/demo"
              className={`nav-link cursor-pointer sm:text-sm lg:text-[15px] md:text-[13px] ${
                location.pathname === "/demo" ? "active" : ""
              }`}
            >
              Demo
            </Link>
        <Link
          to="/our-team"
          
          className={`nav-link cursor-pointer sm:text-sm lg:text-[15px] md:text-[13px] ${location.pathname ==="/our-team" ? "active" : ""}`}
          
        >
          Our Team
        </Link>
        <Link
          to="/contact"
          
          className="nav-link cursor-pointer sm:text-sm lg:text-[15px] md:text-[13px]"
          
        >
          Contact
        </Link>

        <Link
          to="career"
          
          className="nav-link cursor-pointer sm:text-sm lg:text-[15px] md:text-[13px]"
          

        >
          Career
        </Link>
      </div> */}

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-4 md:space-x-4 lg:space-x-8">
            {/* {[
              { to: "/", label: "Home" },
              { to: "/about", label: "About Us" },
              { to: "/services", label: "Services" },
            //   { to: "/Tech", label: "Tech Stacks" },
            //   { to: "/demo", label: "Demo" },
            //   { to: "/our-team", label: "Our Team" },
            { to: "/insights", label: "Insights" },
            { to: "/Teckstacks", label: "Teckstacks" },
              { to: "/contact", label: "Contact" },
            //   { to: "/career", label: "Career" },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`nav-link cursor-pointer sm:text-sm md:text-[13px] lg:text-[15px]  ${
              location.pathname === item.to
                ? " border-b-4 border-[#2a627a] text-[#2a627a] font-semibold "
                : ""
            }`}
              >
                {item.label}
              </Link>
            ))} */}

            <Link
              to="/"
              className={`nav-link cursor-pointer sm:text-sm md:text-[13px] lg:text-[15px] ${location.pathname === "/" ? "active border-b-4 border-[#2a627a] text-[#2a627a] font-semibold" : ""
                }`}
            >
              Home
            </Link>

            <Link
              to="/Services"
              className={`nav-link cursor-pointer sm:text-sm md:text-[13px] lg:text-[15px] ${location.pathname.includes("/Services") ? "active border-b-4 border-[#2a627a] text-[#2a627a] font-semibold" : ""
                }`}
            >
              Services
            </Link>

            {/* <Link
              to="insights"
              className={`nav-link cursor-pointer sm:text-sm md:text-[13px] lg:text-[15px] ${location.pathname === "/insights" ? "active border-b-4 border-[#2a627a] text-[#2a627a] font-semibold" : ""
                }`}
            >
              Insights
            </Link> */}
            <Link
              to="/teckstacks"
              className={`nav-link cursor-pointer sm:text-sm md:text-[13px] lg:text-[15px] ${location.pathname === "/teckstacks" ? "active border-b-4 border-[#2a627a] text-[#2a627a] font-semibold" : ""
                }`}
            >
              Tech Stacks
            </Link>
            <Link
              to="/About"
              className={`nav-link cursor-pointer sm:text-sm md:text-[13px] lg:text-[15px] ${location.pathname === "/About" ? "active border-b-4 border-[#2a627a] text-[#2a627a] font-semibold" : ""
                }`}
            >
              About Us
            </Link>
            <Link
              to="/Contact"
              className={`nav-link cursor-pointer sm:text-sm md:text-[13px] lg:text-[15px] ${location.pathname === "/Contact" ? "active border-b-4 border-[#2a627a] text-[#2a627a] font-semibold" : ""
                }`}
            >
              Contact
            </Link>

          </div>


          {/* mobile view  */}
          <div className="flex items-center space-x-4 md:space-x-6 lg:space-x-8 ">
            <div className="relative flex items-center box-sizing-border">

            </div>
            <button
              className="md:hidden outline-none focus:outline-none"
              onClick={toggleMenu}
            >
              <svg className="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
              </svg>
            </button>
          </div>
        </div>
        {/* Mobile Menu */}

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="bg-[#FFFFFF] md:hidden p-4 text-center">
            {[
              { to: "/", label: "Home" },
              { to: "/About", label: "About Us" },
              { to: "/Services", label: "Services" },
              // { to: "/Insights", label: "Insights" },
              //   { to: "/Tech", label: "Tech Stacks" },
              //   { to: "/demo", label: "Demo" },
              //   { to: "/our-team", label: "Our Team" },
              { to: "/Teckstacks", label: "Teckstacks" },
              { to: "/Contact", label: "Contact" },
              //   { to: "/career", label: "Career" },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`block py-2 nav-link cursor-pointer sm:text-sm lg:text-md w-full hover:bg-gray-200 hover:text-black  ${location.pathname === item.to ? "text-[#04AA6C]" : "hover:text-[#04AA6C]"
                  }`}
                onClick={toggleMenu}
              >
                {item.label}
              </Link>
            ))}
          </div>
        )}
        {/* <Outlet/> */}
      </div>
    </div>

  );
};

export default Header;
